<template>
  <div class="exclusive-wrap">
    <ul v-if="!!recproductsData">
      <li v-for="(items, index) in recproductsData" :key="index" @click="toLinkUrl(items)"> 
        <div>
          <van-image :src="items.logo_img"/>
        </div>
        <div>
          <p>{{items.name}}</p>
          <p><span>月利率：<em>{{items.monthly_interest}}%</em></span><span>额度：<em>{{items.min_amount}}~{{items.max_amount}}万</em></span></p>
        </div>
      </li>
      <!-- <li>
        <div>
          <van-image
              :src="require('../../../assets/loan/sucicon.png')"
            />
        </div>
        <div>
          <p>车贷在线产品车贷在线产品车贷在线产品车贷在线产品车贷在线车贷在线产品车贷在线产品车贷在线产品车贷在线产品车贷在线产品产品</p>
          <p><span>月利率：<em>0.66~0.88%</em></span><span>额度：<em>20~50万</em></span></p>
        </div>
      </li> -->
    </ul>
    <div class="loanNullData" v-else>暂无产品</div>
  </div>
</template>
<script>
import { Image as VanImage } from 'vant'
import { mapActions, mapState } from 'vuex'
export default {
  data() {
    return {
      channel_lable: window.localStorage.getItem('channel')
    }
  },
  created() {
    this.handleRecproducts()
  },
  methods: {
    ...mapActions(['fetchCommon']),
    handleRecproducts() {
      this.fetchCommon({
        request: 'loan/recproducts',
        path: 'loan/recproducts',
        data: {
          channel_id: this.channel_lable
        }
      })
    },
    toLinkUrl(items) {
      this.fetchCommon({
        request: 'loan/click-nums',
        path: 'loan/click-nums',
        data: {
          channel_id: this.channel_lable,
          product_id: items.id
        },
        onSuccess: () => {
          location.href = items.loan_url
        }
      })
      
    }
  },
  computed: {
    ...mapState({
      recproductsData(state) {
        return state.common['loan/recproducts'].data
      }
    })
  },
  components: {
    [VanImage.name]: VanImage
  }
}
</script>